import React, { useState } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight, MapPin } from 'lucide-react';
import { reviews } from '../mock';

const Reviews = () => {
  const [active, setActive] = useState(0);
  const r = reviews[active];

  const next = () => setActive((a) => (a + 1) % reviews.length);
  const prev = () => setActive((a) => (a - 1 + reviews.length) % reviews.length);

  return (
    <section id="reviews" className="relative py-28 bg-[#0d0d0d]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="text-amber-400 tracking-[0.32em] text-[12px] mb-5 font-medium">REVIEWS</p>
            <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              What students are <span className="text-amber-400 italic">saying</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={prev}
              className="w-12 h-12 rounded-full border border-white/20 text-white/80 hover:border-amber-400 hover:text-amber-400 flex items-center justify-center transition-colors duration-300"
              aria-label="Previous"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={next}
              className="w-12 h-12 rounded-full border border-white/20 text-white/80 hover:border-amber-400 hover:text-amber-400 flex items-center justify-center transition-colors duration-300"
              aria-label="Next"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7 relative rounded-2xl border border-amber-400/30 bg-gradient-to-br from-amber-400/[0.07] to-transparent p-10 lg:p-14">
            <Quote size={56} className="text-amber-400/30" strokeWidth={1.2} />
            <p className="mt-4 text-white text-2xl lg:text-[26px] font-serif leading-[1.5]">
              “{r.text}”
            </p>
            <div className="mt-8 flex items-center gap-1 text-amber-400">
              {Array.from({ length: r.rating }).map((_, i) => (
                <Star
                  key={`featured-${r.id}-star-${i}`}
                  size={18}
                  fill="currentColor"
                  strokeWidth={0}
                />
              ))}
            </div>
            <div className="mt-6 flex items-center justify-between flex-wrap gap-3">
              <div>
                <div className="text-white text-lg font-medium">{r.name}</div>
                <div className="text-white/55 text-sm flex items-center gap-2 mt-1">
                  <span>{r.rank}</span>
                  <span className="text-amber-400/60">•</span>
                  <MapPin size={12} /> {r.country}
                </div>
              </div>
              <div className="text-white/40 text-sm tracking-wider">
                {String(active + 1).padStart(2, '0')} / {String(reviews.length).padStart(2, '0')}
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
            {reviews.map((rv, i) => (
              <button
                key={rv.id}
                onClick={() => setActive(i)}
                className={`text-left p-5 rounded-xl border transition-all duration-300 ${
                  i === active
                    ? 'border-amber-400/60 bg-amber-400/[0.06]'
                    : 'border-white/10 bg-white/[0.02] hover:border-white/25'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="text-white font-medium">{rv.name}</div>
                  <div className="flex items-center gap-0.5 text-amber-400">
                    {Array.from({ length: rv.rating }).map((_, k) => (
                      <Star
                        key={`side-${rv.id}-star-${k}`}
                        size={11}
                        fill="currentColor"
                        strokeWidth={0}
                      />
                    ))}
                  </div>
                </div>
                <div className="text-white/50 text-xs mt-1">
                  {rv.rank} · {rv.country}
                </div>
                <p className="text-white/65 text-[14px] mt-3 line-clamp-2">{rv.text}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
